import shuffle from 'lodash/shuffle';
import constants from 'Constants';
import * as comUtils from 'utils/Common';
import * as cookieUtils from 'utils/Cookie';

export function identify(consoleStore) {
  if (!window.OnVoard) return;

  const account = consoleStore.account;
  const user = consoleStore.user;

  try {
    let currentTs = comUtils.getCurrentTimestamp();
    let lastIdentifiedTs = cookieUtils.getCookie('web_tracking_identified');
    if (lastIdentifiedTs) {
      let diff = parseInt(currentTs - lastIdentifiedTs);
      if (120 >= diff) return;
    }

    let contactData = {};
    contactData["email"] = user.email;
    contactData["name"] = user.name;
    OnVoard('web_tracking', 'identify', contactData);
    cookieUtils.setSessionCookie('web_tracking_identified', currentTs);
  } catch(error) {
    console.error(error);
  }
}

export function getEngagedActions() {
  const cookieName = constants.COOKIE_ENGAGED_MARKETING_ACTIONS;
  let data = cookieUtils.getCookie(cookieName);
  data = data ? JSON.parse(data) : {};
  return data;
}

export function hasEngagedAction(key) {
  let data = getEngagedActions();
  if (!data) return false;
  if (data[key]) return true;
  return false;
}

export function hasEngagedReviewRequestAction() {
  let data = getEngagedActions();
  if (!data) return false;
  let keys = Object.keys(data);
  return keys.some((key) => key.endsWith("review_request"));
}

export function hasEngagedAppPromoteAction() {
  let data = getEngagedActions();
  if (!data) return false;
  let keys = Object.keys(data);
  return keys.some((key) => key.endsWith("app_promote"));
}

function getAppPromoteAction(consoleStore, currentProduct) {
  if (hasEngagedAppPromoteAction()) return;
  // for now we don't use cross app promote
  return;

  // const account = consoleStore.account;

  // const eligiblePlatforms = [
  //   constants.ECOMMERCE_PLATFORM_SHOPIFY,
  //   constants.ECOMMERCE_PLATFORM_EASYSTORE,
  // ];

  // if (!eligiblePlatforms.includes(account.ecommercePlatform)) return;

  // let actions = [];
  // actions.push({product: constants.PRODUCT_BACK_IN_STOCK, key: "backinstock_app_promote"});
  // actions.push({product: constants.PRODUCT_MARKETING_PLATFORM, key: "marketingplatform_app_promote"});
  // actions.push({product: constants.PRODUCT_REVIEWS, key: "reviews_app_promote"});
  // actions.push({product: constants.PRODUCT_RECOMMENDER, key: "recommender_app_promote"});
  // actions.push({product: constants.PRODUCT_PROMPT, key: "prompt_app_promote"});
  // actions = shuffle(actions);

  // let actionKey = null;
  // actions.forEach((action) => {
  //   if (actionKey) return;
  //   if (action.product === currentProduct) return;
  //   if (account.activeProducts.includes(action.product)) return;
  //   actionKey = action.key;
  // })

  // return actionKey;
}

function getReviewRequestAction(account) {
  if (account.isEcommercePlatformShopify) return "shopify_review_request";
  if (account.isEcommercePlatformBigCommerce) return "bigcommerce_review_request";
  if (account.isEcommercePlatformWix) return "wix_review_request";
  return "g2_review_request";
}

export function getMarketingActions(consoleStore, currentProduct) {
  const account = consoleStore.account;
  const organization = consoleStore.organization;
  const user = consoleStore.user;

  const actions = [];

  // current product must be active
  if (!account.activeProducts.includes(currentProduct)) return actions;

  if (account.eligibleReviewRequest) {
    let reviewRequestAction = getReviewRequestAction(account);
    if (!hasEngagedAction(reviewRequestAction)) actions.push(reviewRequestAction);
  }

  let appPromoteAction = getAppPromoteAction(consoleStore, currentProduct);
  if (appPromoteAction) actions.push(appPromoteAction);

  return actions;
}

export function recordEngagedAction(key) {
  const cookieName = constants.COOKIE_ENGAGED_MARKETING_ACTIONS;
  const currentTs = Math.floor(Date.now() / 1000);

  let data = cookieUtils.getCookie(cookieName);
  data = data ? JSON.parse(data) : {};
  data[key] = currentTs;
  cookieUtils.setCookie(cookieName, data);

  if (key.endsWith("review_request")) {
    if (window.OnVoard) {
      window.OnVoard('web_tracking', 'track', 'custom.engaged_review_request', {});
    }
  }
}

